var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"timetableCardWrapperRef",staticClass:"dcw-timeline-mobile-wrapper",class:[
    {
      'dcw-timeline-mobile-wrapper--center-card-first': _vm.calibrateCardToBeInCenter && _vm.eventDot.index === 0,
      'dcw-timeline-mobile-wrapper--center-card': _vm.calibrateCardToBeInCenter && _vm.eventDot.index !== 0
    }
  ],attrs:{"data-index":_vm.eventDot.index}},[_c('DcwTimelineMobileCard',{attrs:{"event":_vm.event}}),_vm._v(" "),_c('DcwTimelineDot',{staticClass:"dcw-timeline-mobile-wrapper__event-dot-progress",attrs:{"data":_vm.eventDot}},[_vm._v("\n    "+_vm._s(_vm.formatDateString(_vm.event.date))+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }